import { getString } from '../locale'

export function readableMemory(bytes: number): string {
    const KB = getString('memory.kb')
    const MB = getString('memory.mb')
    const GB = getString('memory.gb')
    if (bytes < 1024) {
        return `${bytes} B`
    } else if (bytes < 1024 * 1024) {
        return `${(bytes / 1024).toFixed(2)} ${KB}`
    } else if (bytes < 1024 * 1024 * 1024) {
        return `${(bytes / (1024 * 1024)).toFixed(2)} ${MB}`
    } else {
        return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} ${GB}`
    }
}
